import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IManagementUnitSearchParamsModel } from '@apps-common/types/management/unit'
import { IUnitTaskGroupModel } from '@apps-common/types/portal/unit-tasks'

export const addTaskGroup = async (
  model: IUnitTaskGroupModel,
  search: IManagementUnitSearchParamsModel,
  searchCount: number,
  hideOrderUnits?: boolean
): Promise<IUnitTaskGroupModel> =>
  axios
    .post('/management/UnitProgramTask/AddTaskGroup', {
      task: model,
      search,
      searchCount,
      hideOrderUnits: hideOrderUnits || false
    })
    .then((res) => res?.data?.data)

type Props = {
  model: IUnitTaskGroupModel
  search: IManagementUnitSearchParamsModel
  searchCount: number
  hideOrderUnits?: boolean
}

export const useManagementAddTaskGroup = (notify?: boolean, onSuccess?: (data: IUnitTaskGroupModel) => void) =>
  useMutation({
    mutationKey: ['addTaskGroup'],
    mutationFn: ({ model, search, searchCount, hideOrderUnits }: Props) => addTaskGroup(model, search, searchCount, hideOrderUnits),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Added task.')
      }
    },
    onError: (error) => {
      if (notify) {
        toastError(error?.message || 'Failed to add task.')
      }
    },
    throwOnError: false
  })
